<template>
    
    <div class="result-images-type-container">
       <ImageSlide
            v-if="items.length > 0"
            :images="items"
            :mini="true"
        ></ImageSlide>

        
    </div>
</template>
<script>
import ImageSlide from '../../../../components/ImageSlide.vue'
export default {
    props: ['items'],
    components: { ImageSlide },
   
    computed: {
      
    },
    data(){
        return{
            // items: [
            //     {
            //         text: "9:00",
            //         count: "4",
            //         active: false,
            //     }
            // ]
          

          

        }
    },
    mounted(){
    },

    methods:{
        
    }


   
}
</script>

<style lang="scss">
    
    .result-images-type{

        &-container{
            padding: 0 5px;
        }
        
    }
</style>